import {
  PatientPortalLoyaltyPoints,
  PatientPortalMyMembership,
  PatientPortalPackageBalance,
  PatientPortalSavedItemBalance,
} from "@/types/patient-portal";

import { requestData } from "@/api/api-config";

export async function listPortalPackageBenefits(): Promise<
  PatientPortalPackageBalance[] | null
> {
  return await requestData<PatientPortalPackageBalance[]>(
    "patient/patient-portal/benefits/packages",
    "get",
  );
}

export async function listPortalSavedItemBenefits(): Promise<
  PatientPortalSavedItemBalance[] | null
> {
  return await requestData<PatientPortalSavedItemBalance[]>(
    "patient/patient-portal/benefits/saved-items",
    "get",
  );
}

export async function listPortalMembershipBenefits(): Promise<
  PatientPortalMyMembership[] | null
> {
  return await requestData<PatientPortalMyMembership[]>(
    "patient/patient-portal/benefits/memberships",
    "get",
  );
}

export async function getPortalLoyaltyPoints(): Promise<PatientPortalLoyaltyPoints | null> {
  return await requestData<PatientPortalLoyaltyPoints>(
    "patient/patient-portal/benefits/loyalty-points",
    "get",
  );
}
